import { tokenRef } from '../store/api/bites-api';

const useToken = () => {
  return { token: tokenRef.current || '' };
};

export default useToken;
